<template>
    <component
      :is="safeLink ? 'a' : 'div'"
      :target="isOpenNewTab ? isTarget_Blank() : undefined"
      :href="safeLink || undefined"
      class="image-item-wrap"
    >
    <LazyImage
      class="image-item"
      :src="showSrc" 
      :fit="config.fit"
    />
      <!-- <el-image 
      class="image-item"
               referrerpolicy="no-referrer"
      loading="lazy"
      :src="config.src" 
      :fit="config.fit"
      ></el-image> -->
    </component>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  import useLocate from './uses/useLocate.js';
  import LazyImage from  "@/components/common/LazyImage/index.vue"
 
  import { getSafeLink, isHttpLink, isTarget_Blank } from '@/utils/globalData.js';
  import { useRenderConfig } from './uses/useRenderConfig.js';
  import { resolveBindDataKeyValue } from '@/utils/renderBinding';
  // 使用 useLocate 钩子
  const { getLocaleText } = useLocate();
  
  // 定义 props
  const props = defineProps({
    currentElementIndex: {
      type: Array,
      default: () => [],
    },
    idx: {
      type: Number,
      default: -1,
    },
    parentKeys: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
    },
  });
  const { bindData } = useRenderConfig(() => props.config);

  const showSrc = computed(() => {
    return resolveBindDataKeyValue(
      bindData.value,
      props.config?.bindDataKey,
      props.config?.src || '',
    );
  });
  
  // 计算属性：当前元素索引字符串
  const currentElementIndexStr = computed(() => {
    return props.currentElementIndex && props.currentElementIndex.length
      ? props.currentElementIndex.join('x')
      : '';
  });

  const safeLink = computed(() => {
    return getSafeLink(props.config?.link);
  });
  
  // 计算属性：是否新开标签页
  const isOpenNewTab = computed(() => {
    return isHttpLink(props.config?.link);
  });
  </script>
  
  <style scoped>
  .image-item-wrap {
    display: block;
    width: 100%;
    height: 100%;
  }
  
  .image-item {
    width: 100%;
    height: 100%;
    display: block;
  }
  </style>
  
